var map = {
	"./android-icon.svg": "8917",
	"./arrow-chart.svg": "05a9",
	"./bar-chart.svg": "bde4",
	"./costs-coin.svg": "7efe",
	"./costs-tractor.svg": "7d39",
	"./firmware-icon.svg": "e108",
	"./gemini-color.svg": "4f10",
	"./icon-espanhol-colorido.svg": "0320",
	"./icon-ingles-colorido.svg": "7612",
	"./icon-portugues-colorido.svg": "0e4a",
	"./icone-activities-list.svg": "bb7dc",
	"./icone-agro-analise.svg": "5da4",
	"./icone-agro-settings.svg": "817b",
	"./icone-agro.svg": "a095",
	"./icone-ajustes.svg": "26ab",
	"./icone-alerta.svg": "1464",
	"./icone-anotacao.svg": "ab3c",
	"./icone-arquivo.svg": "7eb9",
	"./icone-barley.svg": "5aa3",
	"./icone-beacon.svg": "d9de",
	"./icone-beans.svg": "7045",
	"./icone-boas-vindas.svg": "b154",
	"./icone-cassava.svg": "d562",
	"./icone-checklist.svg": "4bb8",
	"./icone-coa-alert.svg": "9ee2",
	"./icone-coa-historical.svg": "0398",
	"./icone-coa-real-time.svg": "b069",
	"./icone-coa-sensor.svg": "3fca",
	"./icone-coffee-beans.svg": "fdb1",
	"./icone-conexao.svg": "ce18",
	"./icone-config-lista.svg": "974a",
	"./icone-contato.svg": "3c0a",
	"./icone-corn.svg": "ce4a",
	"./icone-costs.svg": "109a",
	"./icone-cottom.svg": "6c67",
	"./icone-disp.svg": "fa2c",
	"./icone-dispositivo.svg": "a4ea",
	"./icone-distribution.svg": "0a37",
	"./icone-entrar.svg": "19c7",
	"./icone-estrada.svg": "de24",
	"./icone-fertilizing.svg": "f915",
	"./icone-fleet-alert.svg": "534c",
	"./icone-fleet-report.svg": "5e17",
	"./icone-fullscreen.svg": "c676",
	"./icone-fungicide.svg": "b5c7",
	"./icone-harvest.svg": "0483",
	"./icone-implemento.svg": "7379",
	"./icone-john-deere-connected-black.svg": "4370",
	"./icone-john-deere-connected-white.svg": "d629",
	"./icone-john-deere-connected.svg": "890d",
	"./icone-john-deere.svg": "9e2f",
	"./icone-leaf.svg": "2aeb",
	"./icone-manual.svg": "6031",
	"./icone-mapa.svg": "e8cc",
	"./icone-maquinario.svg": "5747",
	"./icone-mensagem.svg": "41ab",
	"./icone-operador.svg": "97a0",
	"./icone-operational-alert.svg": "fe77",
	"./icone-orange.svg": "6fde",
	"./icone-org-config.svg": "de8b",
	"./icone-organization.svg": "5f34",
	"./icone-parada-red.svg": "29a1",
	"./icone-play.svg": "a58e",
	"./icone-propeller.svg": "cf3e",
	"./icone-relatorio.svg": "5dca",
	"./icone-relatorios-1.svg": "2432",
	"./icone-relogio.svg": "7d96",
	"./icone-revisao.svg": "8f13",
	"./icone-rice.svg": "6786",
	"./icone-sair.svg": "40ab",
	"./icone-seeding.svg": "a09a",
	"./icone-soil-preparation.svg": "05d0",
	"./icone-soy.svg": "bfe6",
	"./icone-sugarcane.svg": "2329",
	"./icone-talhoes.svg": "d20f",
	"./icone-task.svg": "c2ff",
	"./icone-trabalhos.svg": "c5dd",
	"./icone-transport.svg": "f35d",
	"./icone-tree.svg": "4822",
	"./icone-trocar-senha.svg": "7afc",
	"./icone-user-edit.svg": "0d25",
	"./icone-webhook-dados-historicos.svg": "bb31",
	"./icone-webhook-shapefile.svg": "8ffd",
	"./icone-webhook.svg": "fe36",
	"./icone-wheat.svg": "6a3e",
	"./machine-report.svg": "f112",
	"./manufacturer-icon.svg": "7128",
	"./pie-chart.svg": "9773",
	"./shop-cart-icon.svg": "a951",
	"./terminal-icon.svg": "ae57",
	"./timezone.svg": "586c",
	"./user-admin-icon.svg": "d8fa",
	"./user-icon.svg": "149a",
	"./vehicles-group.svg": "d33c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";